<template>
    <div class="project_container">
      <div class="intel_part01  projectBg">
        <div>
          <p>时代对“效率”提出要求</p>
          <button @click="showProjectDialog = true">立即试用</button>
        </div>
      </div>
      <div class="intel_part02">
        <div>
          <img class="intel_image01 projectImg01" src="../assets/images/project01.png" alt="">
          <div>
            <h1>项目运营中的痛点</h1>
            <ul>
              <li>工作计划不落地</li>
              <li>组织责任不明确</li>
              <li>绩效目标不合理</li>
              <li>过程管控不到位</li>
              <li>战略目标不清晰</li>
              <li>绩效评估形式化</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part03 projectPart02">
        <div>
          <img class="projectImg02" src="../assets/images/project02.png" alt="">
          <div>
            <h1>赋能项目管控，实现运营效率</h1>
            <ul>
              <li>企业内部对计划项目管理的先进程度，不仅是企业管理信息化的重要标志，也是企业深化管理、提高效益的有利手段</li>
              <li>基于项目做计划细分责任落实到个人，管理人随时掌控计划进程说明、状态、进度、掌控整体情况。经营目标分解上下战略一致才可以赋能项目计划解决时代对效率提成的要求。</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 projectPart03">
        <div>
          <img class="intel_image01" src="../assets/images/project03.png" alt="">
          <div>
            <h1>点 线 面 体 全景运营视角</h1>
            <ul>
              <li>经营管控 (体) 的战略</li>
              <li>到项目 (面) 的管理掌控</li>
              <li>到（线）关键路径计划落实</li>
              <li>到（点）个人计划进度说明和日报、周报、月报，日程</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part03 projectPart04">
        <div>
          <img src="../assets/images/project04.png" alt="">
          <div>
            <h1>定义企业目标生命线</h1>
            <ul>
              <li>向导式牵引企业制定年度业务、预算、管理等核心经营目标，并逐层进行目标分解，定义企业目标生命线，量化目标责任书，让经营目标管理清晰可控。</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 projectPart04">
        <div>
          <img class="intel_image01" src="../assets/images/project05.png" alt="">
          <div>
            <h1>可视化管理项目</h1>
            <ul>
              <li>透明化地呈现项目的「进行中 未开始 未完成 已完成 延期」各个关键阶段进度说明，基于项目做出细分到人计划、进度说明、时间节点，周期，分工明确地落实到负责人，清晰地管控项目整体运营情况。</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part03 intel_part11 projectPart06">
        <div>
          <img  src="../assets/images/project06.png" alt="">
          <div>
            <h1>全景运营尽在掌握</h1>
            <ul>
              <li>连通多个系统，形成统一的全景运营平台。ERP、财务、CRM 等各类 IT 系统多而分散，现在都可以与 益企营项目计划 进行信息和数据连通，并形成报表。只需登录 益企营平台，全景运营情况核心信息一览无余。</li>
            </ul>
          </div>
        </div>
      </div>
      <my-dialog :show-dialog.sync="showProjectDialog"></my-dialog>
    </div>
</template>

<script>
    import myDialog from '../components/my-dialog'
    export default {
        name: "",
        data:function(){
          return{
            showProjectDialog:false
          }
        },
        components:{myDialog}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/project.vue